interface Props {
  method: string;
}

const COLORS: Record<string, string> = {
  litellm_table: "bg-green-900/40 text-green-300 border-green-700/50",
  msg_cloud_ai_table: "bg-green-900/40 text-green-300 border-green-700/50",
  msg_cloud_ai_pending:
    "bg-yellow-900/40 text-yellow-300 border-yellow-700/50",
  msg_cloud_ai_backfilled:
    "bg-cyan-900/40 text-cyan-300 border-cyan-700/50",
  manual_calc: "bg-purple-900/40 text-purple-300 border-purple-700/50",
  audit: "bg-kw-bg-overlay text-kw-text-muted border-kw-border-strong",
};

const TITLE: Record<string, string> = {
  litellm_table: "Pricing aus LiteLLM's Provider-Tabelle.",
  msg_cloud_ai_table: "Pricing aus persist.config['msg_cloud_ai_pricing'].",
  msg_cloud_ai_pending:
    "msg_cloud_ai: Pricing-Entry fehlt — wartet auf Backfill durch /v1/admin/msg-cloud-ai-backfill.",
  msg_cloud_ai_backfilled:
    "msg_cloud_ai-Pricing nachträglich gefüllt (Backfill-Job).",
  manual_calc: "Manuell berechnet (Callback-Error-Path).",
  audit: "Audit-only-Eintrag (kein USD-Kostenpunkt).",
};

export default function EstimationMethodBadge({ method }: Props) {
  const cls = COLORS[method] ?? "bg-kw-bg-overlay text-kw-text-muted border-kw-border-strong";
  const title = TITLE[method] ?? method;
  return (
    <span
      className={`inline-block px-1.5 py-0.5 text-[10px] rounded border ${cls}`}
      title={title}
    >
      {method}
    </span>
  );
}
